import { render, staticRenderFns } from "./Feel-good-stretches.vue?vue&type=template&id=54bcf690"
import script from "./Feel-good-stretches.vue?vue&type=script&lang=js"
export * from "./Feel-good-stretches.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports